/* eslint-disable no-console */
'use strict';
import getMpEnv from './getMpEnv.js';
/* eslint-disable*/
/* 北京 */
const DEFAULT_COORDS = {
    type: 'default',
    longitude: 116.38928064527734,
    latitude: 39.92365212001548
};
let cacheCoords;

const getCurrentCoords = (accuracy, timeout)=>{
    const env = getMpEnv();
    return new Promise(function(resolve, reject) {
        try{
            if (cacheCoords) {
                resolve(cacheCoords);
                return;
            }
            // 小程序
            if (env && (env.mpName === 'wx' || env.mpName === 'swan')) {
                hysdk.ready(() => {
                    if (env.mpName === 'wx') {
                        window.wx.getLocation({
                            highAccuracyExpireTime: timeout || 3000,
                            isHighAccuracy: accuracy || true,
                            success: function (res) {
                                cacheCoords = {
                                    latitude: res.latitude,
                                    longitude: res.longitude
                                }
                                resolve(cacheCoords || DEFAULT_COORDS)
                            },
                            fail: function () {
                                resolve(DEFAULT_COORDS)
                            },
                            cancel: function  () {
                                resolve(DEFAULT_COORDS)
                            }
                        });
                    } else {
                        window.swan.getLocation({
                            highAccuracyExpireTime: timeout || 3000,
                            isHighAccuracy: accuracy || true,
                            success: function (res) {
                                cacheCoords = {
                                    latitude: res.latitude,
                                    longitude: res.longitude
                                }
                                resolve(cacheCoords || DEFAULT_COORDS)
                            },
                            fail: function () {
                                resolve(DEFAULT_COORDS)
                            }
                        });
                    }
                });
            } else {
                hysdk.ready(() => {
                    hysdk.getLocation({
                        success: function(geo) {
                            geo && geo.coords && (cacheCoords = geo.coords);
                            resolve(cacheCoords || DEFAULT_COORDS);
                        },
                        fail: function(err) {
                            resolve(DEFAULT_COORDS);
                        }
                    });
                });
            }
        } catch(e) {
            resolve(DEFAULT_COORDS);
        }
    });
};
export default getCurrentCoords;